import OrderHistoryCard from './OrderHistoryCard';

export default OrderHistoryCard;
